import { useTranslation } from 'react-i18next';
import type { SettingsProfileFormProps } from './SettingsProfileForm.types';

export const useSettingsProfileForm = (props: SettingsProfileFormProps) => {
  const { t } = useTranslation();
  return { t, ...props };
};
